module.exports = __webpack_public_path__ + "assets/img/TermsBAPC.e99e5e2d.png";